import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-text',
  components: {},
})
export default class DisplayFieldText extends mixins(AbstractDisplayField) {
  get valueLabel(): string {
    const item = this.fieldConfig.valueToLabel?.find(item => item.value === this.value);

    return item?.label || item?.text || this.value;
  }

  get showDataHoverIcon() {
    return this.fieldConfig.dataHoverIcon
      ? Object.keys(this.fieldConfig.dataHoverIcon).length > 0
      : false;
  }

  get hoverIcon() {
    const data = this.fieldConfig.dataHoverIcon;
    return data['icon'];
  }

  get hoverData() {
    const data = this.fieldConfig.dataHoverIcon;
    return this.item[data['data']];
  }
}
